import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-89bf7de8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuBase = _resolveComponent("MenuBase");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MenuBase, { class: "menu" }),
        _hoisted_2
    ]));
}
